import React, { useState } from 'react';

import { AuthLayout } from '@/components/Auth/AuthLayout';
import { useNavigate } from 'react-router-dom';
import { UserService } from '@/services/UserService';
import { createErrorNotification } from '@/helper/ApiHelper';
import { useTranslation } from 'react-i18next';

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [errorHighlights, setErrorHighlights] = useState<string[]>([]);
  const [email, setEmail] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const [resetFinish, setResetFinish] = useState(false);

  const sendResetPasswordEmail = () => {
    setIsLoading(true);
    setResetFinish(false);
    setErrorHighlights([]);

    UserService.resetPassword(email)
      .then(() => {
        setResetFinish(true);
        setEmail('');
      })
      .catch((err) => {
        setErrorHighlights(['email']);
        createErrorNotification(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <AuthLayout>
      <div className="w-[85%] max-w-[400px] mx-auto">
        <h2 className="text-2xl font-semibold py-2">{t('auth.password_reset.title')}</h2>
        <div className={'mt-2 text-gray-600 mb-4'}>{t('auth.password_reset.description')}</div>
        <div className="form-control w-full mb-3">
          <label className="label">
            <span className="label-text">{t('auth.email')}</span>
          </label>
          <input
            type="email"
            placeholder="your@mail.com"
            className={[
              errorHighlights.includes('email') ? 'border border-error' : '',
              'input input-bordered w-full',
            ].join(' ')}
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />
          {resetFinish && (
            <label className="mt-2 pl-1 text-secondary text-sm">
              {t('auth.password_reset.reset_success_message')}
            </label>
          )}
        </div>
        <div className="flex flex-col space-y-3">
          <button
            className={'btn btn-primary text-white w-full disabled:text-white'}
            onClick={sendResetPasswordEmail}
            disabled={isLoading || email === ''}
          >
            {t('auth.password_reset.confirm_button')}
          </button>
          <button className={'btn btn-outline w-full'} onClick={() => navigate('/auth/login')}>
            {t('general.to') + ' ' + t('auth.login_page')}
          </button>
        </div>
      </div>
    </AuthLayout>
  );
}
